import {useAtom} from 'jotai'

import {useCart} from 'react-use-cart'
import {BasketAtom, BasketIdAtom} from '../store/basket'
import {detailAtom, listAtom, listFilterAtom} from '../store/market'

export const useMarket = () => {
  const {totalUniqueItems} = useCart()

  const [detail, detailSet] = useAtom(detailAtom)

  const [list, listSet] = useAtom(listAtom)
  const [listFilter, listFilterSet] = useAtom(listFilterAtom)

  const [basketId, basketIdSet] = useAtom(BasketIdAtom)
  const [basket, basketSet] = useAtom(BasketAtom)

  return {
    totalUniqueItems,
    detail,
    detailSet,
    list,
    listSet,
    listFilter,
    listFilterSet,
    basketId,
    basketIdSet,
    basket,
    basketSet,
  }
}
